import React from 'react';
import { connect } from 'react-redux';
import {
  clientErrors, checkRequired, checkMaxLength, validationClasses,
} from '@/utils/errors';
import fieldNames, { fieldLengths } from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';
import DatasetConditionContainer, {
  mapStateToProps,
  mapDispatchToProps,
} from '../components/DatasetConditionContainer';

export const validateUserDefinedTextRestriction = (datasetCondition, errors, required = true) => {
  const { text } = datasetCondition.context;
  const entity = 'dataset.condition';
  const title = 'dataset.condition.validation.invalid.title';
  const fields = [fieldNames.DESCRIPTION];

  checkRequired(text, fields, errors, entity, title, required, 'validation.description.required');
  checkMaxLength(text, fields, errors, entity, title, fieldLengths.massive);
};

const UserDefinedTextRestrictionEditor = ({
  datasetCondition,
  updateProperties,
  saveStatus,
  saveErrors,
}) => {
  const textError = clientErrors(saveErrors).find((e) => e.fields.includes(fieldNames.DESCRIPTION));

  const { context } = datasetCondition;

  return (
    <div>
      <DatasetConditionContainer
        error={textError}
        htmlFor="ADDUC_0005_text"
        labelId="dataset.condition.workspace.text.label"
      >
        <MarkdownEditor
          id="ADDUC_0005_text"
          disabled={saveStatus === states.PENDING}
          value={context.text}
          maxEditorHeight={100}
          onChange={(e) => { updateProperties({ text: e }, fieldNames.DESCRIPTION); }}
          className={validationClasses(textError)}
        />
      </DatasetConditionContainer>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDefinedTextRestrictionEditor);
